import React from 'react';
import { Row, Col, Divider, Tooltip, Switch,theme } from 'antd';
import {
  BarChartOutlined,
  LineChartOutlined,
  BoxPlotOutlined,
  DotChartOutlined,
  ZoomInOutlined,
  DownloadOutlined,
  EnvironmentOutlined,
  TableOutlined,
} from '@ant-design/icons';
// import DataFilter from '../DataFilter';
import ZoomReset from './icons/ZoomReset';
import { CHART_TYPE, DB_ICONS, LAYOUTS } from '../dbConstants';
import MotorIcon from './icons/MotorData';
import TelemetryIcon from './icons/TelemetryIcon';
import BatteryData from './icons/BatteryData';
// import CustomData from './icons/CustomData';
// import BatteryCell from './icons/BatteryCell';
import Accelerometer from './icons/Accelerometer';

const { useToken } = theme;

const Toolbar = ({ 
  selectedChart, 
  selectedLayout, 
  crossHair=false,
  enableZoom,
  queryFieldsChange, 
  onChartChange, 
  onLayoutChange, 
  onOtherIconsClick
}) => {
  
  const { token } = useToken();
  const styles = {
    section: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      // padding: '0 12px',
    },
    layoutTitle: {
      alignItems: 'left',
      fontWeight: 'bold',
      fontSize: '18px',
      padding: '0 8px',
    },
    iconGroup: {
      display: 'flex',
      width: "100%",
      // gap: '20px',
    },
    icon: {
      fontSize: '24px',
      cursor: 'pointer',
      alignItems: 'center',
    },
    selectedIcon: {
      fontSize: '24px',
      cursor: 'pointer',
      color: token.colorPrimary,
    },
    disabledIcon: {
      fontSize: '24px',
      cursor: 'not-allowed',
      color: "#c2c1c1",
    },
    divider: {
      height: '50px',
      borderColor: "#c2c1c1"
    },
  };

  return (
    <div style={styles.toolbar}>
      <Row gutter={[16,16]} align="middle" >
        {/* Data Section */}
        <Col xs={24} sm={8} md={10} lg={5} xl={4} style={styles.layoutTitle}>
        <span>
              { selectedLayout === 'IMU' ? 'Accelerometer Data' :
                selectedLayout === 'BATTERYCELL' ? 'Battery Cells Data' :
              `${selectedLayout[0].toUpperCase()+selectedLayout.slice(1).toLowerCase()} Data`}</span>
       </Col>
        <Col xs={24} sm={16} md={14} lg={8} style={styles.section}>
            <Row justify={"space-evenly"} style={styles.iconGroup}> 
            <Col>
            <Tooltip title="Telemetry Data">
            <TelemetryIcon
              style={selectedLayout===LAYOUTS.TELEMETRY ? styles.selectedIcon : styles.icon}
              onClick={() => onLayoutChange(LAYOUTS.TELEMETRY)}
            />
          </Tooltip>
          </Col>
          <Col>
            <Tooltip title="Location Data">
            <EnvironmentOutlined 
              style={selectedLayout===LAYOUTS.LOCATION ? styles.selectedIcon : styles.icon}
              onClick={() => onLayoutChange(LAYOUTS.LOCATION)}
            />
          </Tooltip>
          </Col>
          <Col>
          <Tooltip title="Accelerometer Data">
            <Accelerometer 
              style={selectedLayout===LAYOUTS.IMU ? styles.selectedIcon : styles.icon}
              onClick={() => onLayoutChange(LAYOUTS.IMU)}
            />
          </Tooltip>
          </Col>
          <Col>
          <Tooltip title="Motor Data">
            <MotorIcon 
              style={selectedLayout===LAYOUTS.MOTOR ? styles.selectedIcon : styles.icon}
              onClick={() => onLayoutChange(LAYOUTS.MOTOR)}
            />
          </Tooltip>
          </Col>
          <Col>
          <Tooltip title="Battery Data">
            <BatteryData 
              style={selectedLayout===LAYOUTS.BATTERY ? styles.selectedIcon : styles.icon}
              onClick={() => onLayoutChange(LAYOUTS.BATTERY)}
            />
          </Tooltip>
          </Col>
          {/* <Col>
          <Tooltip title="Battery Cells Data">
            <BatteryCell
              style={styles.disabledIcon}
              onClick={() => onLayoutChange(LAYOUTS.BATTERYCELL)}
            />
          </Tooltip>
          </Col>
          <Col>
          <Tooltip title="Select Data">
            <div style={{alignItems: 'center'}}>
            <CustomData  
              style={styles.disabledIcon}
              // onClick={() => onLayoutChange(LAYOUTS.VEHICLE)}
            /> */}
            {/* <DataFilter 
            queryFieldsChange={queryFieldsChange}
            style={{width: '150px'}}
            disabled={false}
            />  */}
            {/* </div>
          </Tooltip>
          </Col> */}
          </Row>
        </Col>

        <Divider type="vertical" style={styles.divider} className='hide-max-md' />

        {/* Charts Section */}
        <Col xs={16} sm={{offset: 8, span: 10}} md={{offset: 10, span:10}} lg={{offset: 0, span:5}} style={styles.section}>
          <Row justify={"space-evenly"} style={styles.iconGroup}>
            <Col>
              <Tooltip title="Time Series">
                <LineChartOutlined 
                  style={selectedChart===CHART_TYPE.TIMESERIES ? styles.selectedIcon : styles.icon}
                  onClick={() => onChartChange(CHART_TYPE.TIMESERIES)}
                />
              </Tooltip>
              </Col>
          <Col>
              <Tooltip title="Histogram">
                <BarChartOutlined  
                  style={selectedChart===CHART_TYPE.HISTOGRAM ? styles.selectedIcon : styles.icon}
                  onClick={() => onChartChange(CHART_TYPE.HISTOGRAM)}
                />
              </Tooltip>
              </Col>
          <Col>
              <Tooltip title="Box Plot">
                <BoxPlotOutlined  
                  style={selectedChart===CHART_TYPE.BOXPLOT ? styles.selectedIcon : styles.icon}
                  onClick={() => onChartChange(CHART_TYPE.BOXPLOT)}
                />
              </Tooltip> 
              </Col>
          <Col>
              <Tooltip title="Scatter Plot">
                <DotChartOutlined  
                  style={selectedChart===CHART_TYPE.SCATTER ? styles.selectedIcon : styles.icon}
                  onClick={() => onChartChange(CHART_TYPE.SCATTER)}
                /> 
              </Tooltip>
              </Col>
          </Row>
        </Col>

        <Divider type="vertical" style={styles.divider} className='hide-max-md' />
       
        {/* Other Icons Section */}
        <Col xs={8} sm={6} md={4} lg={5} xl={6} style={styles.section}>
          <Row justify={"space-evenly"} style={styles.iconGroup} align={"middle"}>
          <Col xs={0} xl={6} className="flex-center">
            <Tooltip className="hide-max-lg" title = {crossHair ? "Switch to Tooltip" : 'Switch to CrossHair'} >
            <Switch
              checkedChildren={crossHair ? "Crosshair" : "Tooltip"} 
              unCheckedChildren={crossHair ? "Crosshair" : "Tooltip"} 
              defaultChecked 
              disabled={[CHART_TYPE.HISTOGRAM, CHART_TYPE.BOXPLOT].includes(selectedChart)}
              onChange={() => onOtherIconsClick(DB_ICONS.CROSSHAIR)}
            />
            </Tooltip>
            </Col>
          <Col xs={0} lg={4} className="flex-center">
            <Tooltip className="hide-max-md" title='Enable Zoom In'>
              <ZoomInOutlined
                style={
                  (selectedChart === CHART_TYPE.TIMESERIES || selectedChart === CHART_TYPE.SCATTER) ? 
                   (enableZoom ? styles.selectedIcon: styles.icon) : styles.disabledIcon}
                onClick={() => onOtherIconsClick(DB_ICONS.ZOOM_IN)}
              />
            </Tooltip>
            </Col>
          <Col xs={0} lg={4} className="flex-center">
            <Tooltip className="hide-max-md" title='Reset Zoom'>
              <ZoomReset color={'#000000'} size={24} style={
                (selectedChart === CHART_TYPE.TIMESERIES || selectedChart === CHART_TYPE.SCATTER) ? 
                styles.icon : styles.disabledIcon}
                onClick={() => onOtherIconsClick(DB_ICONS.ZOOM_RESET)}
              />
            </Tooltip>
            </Col>
          <Col xs={12} lg={4} className="flex-center">
            <Tooltip title={"View Data"}>
              <TableOutlined 
                onClick={() => onOtherIconsClick(DB_ICONS.DATA)} 
                style={styles.icon}/>
            </Tooltip>
            </Col>
          <Col xs={12} lg={4} className="flex-center">
            <Tooltip title="Download">
              <DownloadOutlined 
                style={styles.icon}
                onClick={() => onOtherIconsClick(DB_ICONS.DOWNLOAD)}
              />
            </Tooltip>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
};

export default Toolbar;
